const okrugObjectsTableColumns: any = [
    {
        headerName: "Учетный номер",
        pdfHeader: "Учетный номер",
        field: "options.cad_num",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Название",
        pdfHeader: "Название",
        field: "options.name",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]

const buildingObjectsTableColumns: any = [
    {
        headerName: "Кадастровый номер",
        pdfHeader: "Кадастровый номер",
        field: "options.cad_num",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Адрес",
        pdfHeader: "Адрес",
        field: "options.readable_address",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const constructionObjectsTableColumns: any = [
    {
        headerName: "Кадастровый номер",
        pdfHeader: "Кадастровый номер",
        field: "options.cad_number",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Адрес",
        pdfHeader: "Адрес",
        field: "options.address_readable_address",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Название",
        pdfHeader: "Название",
        field: "options.params_name",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Назначение",
        pdfHeader: "Назначение",
        field: "options.params_purpose",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const unfinishedBuildingObjectsTableColumns: any = [
    {
        headerName: "Кадастровый номер",
        pdfHeader: "Кадастровый номер",
        field: "options.cad_num",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Адрес",
        pdfHeader: "Адрес",
        field: "options.readable_address",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Назначение",
        pdfHeader: "Назначение",
        field: "options.purpose",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const landPlotObjectsTableColumns: any = [
    {
        headerName: "Кадастровый номер",
        pdfHeader: "Кадастровый номер",
        field: "options.cad_num",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Адрес",
        pdfHeader: "Адрес",
        field: "options.readable_address",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const ZOUITObjectsTableColumns: any = [
    {
        headerName: "Реестровый номер границы",
        pdfHeader: "Реестровый номер границы",
        field: "options.reg_numb_border",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Наименование",
        pdfHeader: "Наименование",
        field: "options.name_by_doc",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]

const forestryObjectsTableColumns: any = [
    {
        headerName: "Реестровый номер границы",
        pdfHeader: "Реестровый номер границы",
        field: "options.reg_numb_border",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Наименование",
        pdfHeader: "Наименование",
        field: "options.name_by_doc",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const coastlinesPolygonalObjectsTableColumns: any = [
    {
        headerName: "Реестровый номер границы",
        pdfHeader: "Реестровый номер границы",
        field: "options.brd_nmb",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Наименование",
        pdfHeader: "Наименование",
        field: "options.name",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]
const coastlinesLinearObjectsTableColumns: any = [
    {
        headerName: "Реестровый номер границы",
        pdfHeader: "Реестровый номер границы",
        field: "options.brd_nmb",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Наименование",
        pdfHeader: "Наименование",
        field: "options.name",
        valueType: "string",
        canBeFiltered: true,
        filterType: "contains",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]

export const rosreestrObjectsTableColumns: any = {
    okrug: okrugObjectsTableColumns,
    building: buildingObjectsTableColumns,
    construction: constructionObjectsTableColumns,
    unfinishedBuilding: unfinishedBuildingObjectsTableColumns,
    landPlots: landPlotObjectsTableColumns,
    cultureZOUIT: ZOUITObjectsTableColumns,
    serviceZOUIT: ZOUITObjectsTableColumns,
    natureZOUIT: ZOUITObjectsTableColumns,
    secureZOUIT: ZOUITObjectsTableColumns,
    otherZOUIT: ZOUITObjectsTableColumns,
    specialZOUIT: ZOUITObjectsTableColumns,
    forestry: forestryObjectsTableColumns,
    coastlinesPolygonal: coastlinesPolygonalObjectsTableColumns,
    coastlinesLinear: coastlinesLinearObjectsTableColumns
}